type MusicToggleButtonProps = {
  isPlaying: boolean;
  onToggle: () => void;
  playLabel?: string;
  pauseLabel?: string;
};

export default function MusicToggleButton({
  isPlaying,
  onToggle,
  playLabel = "Play wedding music",
  pauseLabel = "Pause wedding music",
}: MusicToggleButtonProps) {
  const label = isPlaying ? pauseLabel : playLabel;

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      aria-pressed={isPlaying}
      title={label}
      className="group inline-flex h-12 w-12 items-center justify-center rounded-full border border-[#d8bc8657] bg-gradient-to-b from-[#8f6b3f] to-[#6f4f2b] text-[#fff5df] shadow-[0_14px_28px_rgba(54,33,13,0.26),inset_0_1px_0_rgba(255,235,197,0.24),inset_0_-8px_14px_rgba(44,24,8,0.22)] backdrop-blur-[10px] transition duration-200 hover:-translate-y-0.5 hover:scale-[1.03] focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#c5a873] active:translate-y-0 active:scale-[0.98]"
    >
      {isPlaying ? (
        <svg
          className="h-5 w-5 drop-shadow-[0_2px_2px_rgba(44,24,8,0.3)]"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <rect x="6.5" y="5" width="4" height="14" rx="1.4" fill="currentColor" />
          <rect x="13.5" y="5" width="4" height="14" rx="1.4" fill="currentColor" />
        </svg>
      ) : (
        <svg
          className="ml-0.5 h-5 w-5 drop-shadow-[0_2px_2px_rgba(44,24,8,0.3)] transition-transform group-hover:scale-105"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path d="M8 6.5V17.5L17.5 12L8 6.5Z" fill="currentColor" />
        </svg>
      )}
    </button>
  );
}
